export default {
  packingListPallets: [],
  packingListPallet: undefined,
};
